/* eslint-disable prefer-destructuring */
/* eslint-disable radix */
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ConfigModule} from 'src/app/data/networking/models/config/responses/configuration-module';
import {ProductCardVm} from 'src/app/view-model/product-card/product-card.vm';
import {Customer} from 'src/app/data/networking/models/customer/customer';
import {algoliaInit, userTokenAlgolia} from 'src/app/ui/algolia/algoliaInit';
import {countryConfig} from 'src/country-config/country-config';
import {PrimeConfig, PrimeSubscription} from 'src/app/data/networking/models/prime/prime';
import {Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState} from 'src/app/app.reducer';
import {ProductInterface} from 'src/app/data/networking/models/shared/responses/product-response';
import {BrowserDetectorService} from 'src/app/data/networking/services/shared/broswer-detector/browser-detector.service';
import {UpdateProductQuantityEvent} from '../../event-listeners/update-product-quantity/update-product-quantity.event';
import {AdvertisedProductsEvent} from '../../event-listeners/advertised-products/advertised-products.event';
import {PlatformDetectionService} from 'src/app/ui/shared/services/detected-platform/platform-detection.service';

@Component({
  selector: 'app-suggest-card',
  templateUrl: './suggest-card.component.html',
  styleUrls: ['./suggest-card.component.scss'],
})
export class SuggestCardComponent implements OnInit, OnDestroy {
  constructor(
    private vm: ProductCardVm,
    private advertisedProd: AdvertisedProductsEvent,
    private updateQuantityEvent: UpdateProductQuantityEvent,
    private store: Store<AppState>,
    private browserDetectorService: BrowserDetectorService,
    private platformDetectionService: PlatformDetectionService,
  ) {
    this.configModule = vm.getConfigurationModules();
  }

  @Input() groupType = '';
  @Input() isOffer = false;
  @Input() isHalf = false;
  @Input() idPrefix = '';
  @Input() product: ProductInterface;
  @Input() isMini = false;
  @Input() positions = '';
  @Input() isHome = false;
  @Input() queryID = '';
  @Input() isAlgolia = false;

  configModule: ConfigModule;
  urlGo: string;
  customer: Customer;
  storeDefault = '26';
  countryConfig: typeof countryConfig = countryConfig;
  primeData: PrimeSubscription;
  primeConfigSubs: Subscription;
  primeStyles: PrimeConfig;
  subs: Subscription[] = [];
  dataBuyAndGet: Object;
  browser = this.browserDetectorService.checkBrowser();
  alive = true;
  updatedItem = null;
  loading = false;
  buyAndGetModalStatus = {open: false};

  ngOnInit() {
    if (this.product?.type === 'GROUP') {
      this.urlGo = this.product?.url;
    } else {
      this.urlGo = this.product?.url
        ? `/producto/${this.product?.url}`
        : `/producto/${this.product?.id}-${this.product?.seoUrl}`;
    }

    this.getPrimeData();
  }

  get suggestedHalf(): boolean {
    return this.isHalf && !this.primeOffer() && !this.shouldDisplayNoPrimePetal();
  }

  get suggestedPrimeHalf(): boolean {
    return this.isHalf && this.primeOffer() && !this.shouldDisplayNoPrimePetal();
  }

  get suggestedFull(): boolean {
    return this.primeOffer() && !this.shouldDisplayNoPrimePetal();
  }

  get isPrimeUser(): boolean {
    return this.primeData?.active;
  }

  get hasValidPrime(): boolean {
    return this.product?.primePrice > 0 && !!this.product?.primeTextDiscount;
  }

  get primeIsBetter(): boolean {
    return this.product?.primePrice > 0 && this.product?.offerPrice > 0
      ? this.product?.primePrice < this.product?.offerPrice
      : true;
  }

  getPrimeData() {
    this.primeConfigSubs = this.store.select('prime').subscribe(({config}) => {
      if (!config?.length) return;

      this.primeStyles = config[0];
      this.vm.getPrimeSubscription().subscribe(res => {
        this.primeData = res;
        this.validateSubscription(res.expirationDate ? res.expirationDate : '');
      });
    });

    this.subs.push(this.primeConfigSubs);
  }

  validateSubscription(expirationDate?: number) {
    if (expirationDate) {
      const today = new Date().getTime();
      this.primeData.active = Boolean(expirationDate >= today);
    }

    if (!this.primeStyles?.feature_active_web && !this.primeData.active) {
      this.product.primeDescription = null;
      this.product.primePrice = null;
      this.product.primeTextDiscount = null;
    }
  }

  algoliaEvent() {
    this.advertisedProd.closeAdvertisedModal(true);
    const user = this.customer?.analyticsUUID || userTokenAlgolia;

    if (this.queryID && this.isAlgolia) {
      const id = this.product?.objectID;
      this.setAlgoliaInit(user, id, {
        queryID: this.queryID,
        positions: [this.positions + 1],
      });

      this.updateQuantityEvent.sendQueryID({queryID: this.queryID});
    } else if (this.queryID && !this.isAlgolia) {
      const id = this.product?.objectID
        ? this.product?.objectID
        : this.product?.id + this.storeDefault;
      this.setAlgoliaInit(user, id, {
        queryID: this.queryID,
        positions: [
          this.queryID && typeof this.positions === 'number'
            ? this.positions
            : parseInt(this.positions),
        ],
      });
    }
  }

  setAlgoliaInit(user: string, id: string, params?: Object) {
    const platform = this.platformDetectionService.detectPlatform();
    let algoliaConfig = {
      eventType: 'click',
      userToken: user,
      eventName: 'Product viewed',
      index: countryConfig.algolia.index,
      objectIDs: [`${id}`],
      source: 'WEB',
      analyticsTags: [platform],
    };
    if (params) {
      algoliaConfig = {...algoliaConfig, ...params};
    }
    algoliaInit('clickedObjectIDs', algoliaConfig);
  }

  primeOffer(): boolean {
    return this.isPrimeUser && this.hasValidPrime && this.primeIsBetter;
  }

  showPriceTag(): boolean {
    const hasStock = this.product?.totalStock;
    return hasStock && (!this.isPrimeUser || !this.hasValidPrime || !this.primeIsBetter);
  }

  showPriceText(): number {
    return this.product.offerPrice && this.product.offerPrice > 0
      ? this.product.offerPrice
      : this.product.fullPrice;
  }

  showPrimePriceTag(): boolean {
    const pricePrime = this.product.primePrice && this.product.primePrice > 0 && this.primeData?.active;
    const stockAvailable = this.product?.totalStock;
    return stockAvailable && pricePrime;
  }

  getPrimePriceColor(): string {
    return this.primeData?.active ? this.primeStyles?.primary_dark_color : '#418fde';
  }

  showPrimePriceText(): boolean {
    const hasStock = this.product?.totalStock;
    const showPrime = this.isPrimeUser && this.hasValidPrime && this.primeIsBetter;
    const showOffer = this.product.offerPrice && this.product.offerPrice > 0;

    return hasStock && (showOffer || showPrime);
  }

  shouldDisplayPrimePetal(): boolean {
    return this.isPrimeUser && this.hasValidPrime && this.primeIsBetter;
  }

  shouldDisplayNoPrimePetal(): boolean {
    return !this.isPrimeUser && this.hasValidPrime;
  }

  shouldDisplayNoPrimePetalTag(): boolean {
    return this.primeData && this.primeStyles?.feature_active_web && !this.primeData.active && this.product.totalStock > 0;
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}
